import React from 'react';

import {
  GridColumnMenuFilterItem,
  GridColumnMenuProps,
  useGridApiContext,
} from '@mui/x-data-grid-premium';

export const CustomColumnMenu = (props: GridColumnMenuProps) => {
  const apiRef = useGridApiContext();
  return (
    <div>
      <GridColumnMenuFilterItem
        {...props}
        onClick={() => apiRef.current.showFilterPanel(props.colDef.field)}
      />
    </div>
  );
};
